import "./Error404.css";
import React from 'react'

export default function Error404() {
  return (
    <div className="Error404">
      <h1 className="error">404</h1>
      <h2>Oops... This page doesn't exist</h2>
    </div>
  )
}